<template>
  <div class="home v2026-shell">
    <header class="v2026-header">
      <a href="#" class="v2026-header-logo" @click.prevent="onClickLogo()" title="BeNeat">
        <img src="https://beneat.co/static/img/main-logo.svg" alt="BeNeat">
      </a>

      <div class="v2026-header-right" v-if="showAdminStatus">
        <div class="admin-status text-muted v2026-header-timer">
          online:&nbsp;<span class="text-success">{{ getAdminActiveTime(now).online }}</span>
        </div>
        <div class="admin-status text-muted v2026-header-timer">
          pause:&nbsp;<span class="text-warning">{{ getAdminActiveTime(now).pause }}</span>
        </div>
        <div class="admin-status v2026-header-status">
          <a href="" @click.prevent="openUpdateAdminStatusModal()">
            <span v-html="$options.filters.activeStatus(admin.active)"></span>
          </a>
        </div>
      </div>
    </header>

    <div class="v2026-body">
    <!-- slot ถือพื้นที่ 64px ใน flex ไว้ ตัว nav ลอยทับเนื้อหาตอนกาง เนื้อหาจึงไม่ขยับ -->
    <div class="v2026-rail-slot" v-if="admin">
    <nav id="v2026RailNav"
         ref="railNav"
         class="v2026-rail"
         :class="{ 'is-expanded': railOpen, 'is-floating': railFloating }"
         aria-label="เมนูหลัก"
         @pointerenter="onRailPointerEnter"
         @pointerleave="onRailPointerLeave"
         @focusin="onRailFocusIn"
         @focusout="onRailFocusOut"
         @keydown.esc="onRailEscape"
         @transitionend="onRailTransitionEnd">
      <!-- scroll อยู่ที่ wrapper นี้ ไม่ใช่ nav: dropup ของ avatar อยู่นอก wrapper จึงไม่ถูกตัด -->
      <div class="v2026-rail-scroll">
        <button v-for="item in railChatItems"
                :key="item.type"
                type="button"
                class="v2026-rail-item"
                :class="{ 'is-active': navItem === item.navItem }"
                :title="item.label"
                :aria-label="railOpen ? null : item.label"
                @click="onClickRailChat(item); collapseRailAfterChoice()">
          <!-- CSS mask, not <img>: it takes the token colour regardless of the SVG's baked-in fills. -->
          <span v-if="item.svg" class="v2026-rail-svg-mask" aria-hidden="true"
                :style="{ '-webkit-mask-image': 'url(' + item.svg + ')', 'mask-image': 'url(' + item.svg + ')' }"></span>
          <i v-else :class="item.icon"></i>
          <span v-if="railOpen" class="v2026-rail-label">{{ item.label }}</span>
          <span class="badge badge-danger v2026-rail-badge"
                v-if="menuCount && menuCount[item.badgeKey]"
                :aria-label="menuCount[item.badgeKey] + ' ' + item.label">{{ menuCount[item.badgeKey] }}</span>
        </button>

        <!-- แสดงเฉพาะตอนกาง: ตอนหุบเป็นไอคอนล้วน ปุ่มนี้จะดูเหมือนเมนูแชทอีกอัน -->
        <button v-if="railOpen && railChatItems.length > 1"
                type="button"
                class="v2026-rail-item v2026-rail-item--edit"
                title="จัดลำดับเมนู"
                @click="openRailOrder">
          <i class="fas fa-sort" aria-hidden="true"></i>
          <span class="v2026-rail-label">จัดลำดับเมนู</span>
        </button>

        <div class="v2026-rail-spacer"></div>

        <button type="button"
                class="v2026-rail-item"
                title="รายงาน"
                :aria-label="railOpen ? null : 'รายงาน'"
                @click="openDashboard(); collapseRailAfterChoice()">
          <span v-if="railBottomItems.reports.svg" class="v2026-rail-svg-mask" aria-hidden="true"
                :style="{ '-webkit-mask-image': 'url(' + railBottomItems.reports.svg + ')', 'mask-image': 'url(' + railBottomItems.reports.svg + ')' }"></span>
          <i v-else :class="railBottomItems.reports.icon"></i>
          <span v-if="railOpen" class="v2026-rail-label">รายงาน</span>
        </button>

        <button type="button"
                class="v2026-rail-item"
                :class="{ 'is-active': navItem === 'settings' }"
                title="การตั้งค่า"
                :aria-label="railOpen ? null : 'การตั้งค่า'"
                @click="onClickSettings(); collapseRailAfterChoice()">
          <span v-if="railBottomItems.settings.svg" class="v2026-rail-svg-mask" aria-hidden="true"
                :style="{ '-webkit-mask-image': 'url(' + railBottomItems.settings.svg + ')', 'mask-image': 'url(' + railBottomItems.settings.svg + ')' }"></span>
          <i v-else :class="railBottomItems.settings.icon"></i>
          <span v-if="railOpen" class="v2026-rail-label">การตั้งค่า</span>
        </button>
      </div>

      <b-dropdown ref="railAvatarDd" class="v2026-rail-avatar-dd" dropup right variant="link" toggle-class="text-decoration-none p-0" menu-class="v2026-avatar-menu"
                  @shown="onRailDropdownShown"
                  @hidden="onRailDropdownHidden">
        <template #button-content>
          <span class="v2026-rail-avatar" :title="admin.name" :aria-label="admin.name">
            <img :src="admin.profile_picture" class="rounded-circle" width="32" alt="">
            <span class="v2026-online-dot"
                  :class="{ 'is-online': admin.active === 1 }"
                  :title="admin.active === 1 ? 'ออนไลน์' : 'ออฟไลน์'"></span>
          </span>
          <span v-if="railOpen" class="v2026-rail-name" :title="admin.name">{{ admin.name }}</span>
        </template>
        <b-dropdown-header class="v2026-avatar-menu-name">{{ admin.name }}</b-dropdown-header>
        <b-dropdown-item @click.prevent="openUpdateAdminStatusModal(); collapseRailAfterChoice()">อัพเดทสถานะ</b-dropdown-item>
        <b-dropdown-item v-if="admin.shift_work_admin" @click.prevent="openModalShiftWorkAdmin(); collapseRailAfterChoice()">เปลี่ยนกะการทำงาน</b-dropdown-item>
        <b-dropdown-item @click="logout(); collapseRailAfterChoice()">ออกจากระบบ</b-dropdown-item>
      </b-dropdown>
    </nav>
    </div>

    <div class="v2026-main">
      <router-view/>
    </div>
    </div>
    <RailOrderModalV2026 :open="showRailOrder"
                         :items="railChatItems"
                         @close="showRailOrder = false"
                         @save="onSaveRailOrder"
                         @reset="onResetRailOrder"/>
    <sweet-modal ref="updateAdminStatusModal" overlay-theme="dark" width="400">
      <div class="text-left">
        <div class="form-group">
          <label class="form-label" for="active">Status</label>
          <div class="input-group">
            <select name="active" id="active" class="form-control" v-model="updateAdminStatusSubmitData.active">
              <option :value="0">offline</option>
              <option :value="1">online</option>
              <option :value="2">pause</option>
            </select>
          </div>
        </div>
        <div class="form-group" v-if="updateAdminStatusSubmitData.active === 2">
          <label class="form-label" for="active">Reason</label>
          <div class="input-group">
            <select name="active" id="active" class="form-control" v-model="updateAdminStatusSubmitData.remark">
              <option value="พักกลางวัน">พักกลางวัน</option>
              <option value="เข้าห้องน้ำ">เข้าห้องน้ำ</option>
              <option value="ประชุม">ประชุม</option>
              <option value="บันทึกข้อมูล">บันทึกข้อมูล</option>
              <option value="พักเบรค">พักเบรค</option>
            </select>
          </div>
        </div>
      </div>
      <div class="form-group" v-if="updateAdminStatusSubmitData">
        <button class="btn btn-warning btn-block" :disabled="admin && admin.active === updateAdminStatusSubmitData.active" @click="updateAdminStatus()">Update</button>
      </div>
    </sweet-modal>

    <search-conversation ref="searchConversation" v-show="false"></search-conversation>

    <CollapsibleFab
      position="bottom-right"
      :bgColor="bgColor"
      :actions="fabActions"
      @addUser="goToPage('https://admin-test.beneat.co/user/create')"
      @addApplicant="goToPage('https://admin-test.beneat.co/report/form-professional-register')"
    />

    <modal-shift-work-admin ref="modalShiftWorkAdmin" :isChangeShift="true"></modal-shift-work-admin>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import SearchConversation from '@/components/coversation/SearchConversation'
import CollapsibleFab from '@/components/CollapsibleFab'
import ModalShiftWorkAdmin from '@/components/modal/ModalShiftWorkAdmin.vue'
import { RAIL_LABELS, visibleRailTypes, applyRailOrder, loadRailOrder, saveRailOrder, clearRailOrder } from '@/constants/railTypes'
import RailOrderModalV2026 from '@/components/RailOrderModalV2026.vue'

// hover ต้องค้างเท่านี้ก่อนกาง (กันกางตอนเมาส์แค่ลากผ่าน) และหุบช้ากว่านิดกันกระพริบตอนออกขอบ
const RAIL_HOVER_OPEN_MS = 150
const RAIL_HOVER_CLOSE_MS = 200
// กันกรณี transitionend ไม่ยิง (แท็บถูกซ่อน ฯลฯ) ต้องยาวกว่า transition width .2s
const RAIL_FLOAT_FALLBACK_MS = 250

function matchesFocusVisible (el) {
  if (!el || !el.matches) return false
  try {
    return el.matches(':focus-visible')
  } catch (e) {
    return false
  }
}

function prefersReducedMotion () {
  return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
}

export default {
  name: 'home',
  components: { ModalShiftWorkAdmin, SearchConversation, CollapsibleFab, RailOrderModalV2026 },

  data () {
    return {
      // navItem: 'conversation-customer',
      updateAdminStatusSubmitData: {},
      // สถานะ rail กาง: local ล้วน ห้ามย้ายไป Vuex (createPersistedState จะเขียนลง localStorage)
      railHoverOpen: false,
      railSuppressed: false,
      railDropdownOpen: false,
      railPointerInside: false,
      railFloating: false,
      // ลำดับ rail ที่แอดมินจัดเอง (localStorage) — null = ตามลำดับ customer_types
      railOrder: null,
      showRailOrder: false,
      railTypeMap: {
        customer: { icon: 'fa fa-user', svg: require('@/assets/icons2026/message-user.svg'), badgeKey: 'inboxCustomerCount', navItem: 'conversation-customer', label: RAIL_LABELS.customer },
        beneat_professional: { icon: 'fa fa-female', svg: require('@/assets/icons2026/ai-user.svg'), badgeKey: 'inboxBeneatProfessionalCount', navItem: 'conversation-beneat-professional', label: RAIL_LABELS.beneat_professional },
        professional: { icon: 'far fa-id-badge', svg: require('@/assets/icons2026/user-group.svg'), badgeKey: 'inboxProfessionalCount', navItem: 'conversation-professional', label: RAIL_LABELS.professional },
        professional_secondary: { icon: 'far fa-id-badge', svg: require('@/assets/icons2026/user-group.svg'), badgeKey: 'inboxProfessionalSecondaryCount', navItem: 'conversation-professional_secondary', label: RAIL_LABELS.professional_secondary },
        sales_product_customer: { icon: 'fas fa-user-circle', svg: require('@/assets/icons2026/message-user.svg'), badgeKey: 'inboxSalesProductCustomerCount', navItem: 'conversation-sales_product_customer', label: RAIL_LABELS.sales_product_customer },
        recruitment_customer: { icon: 'fas fa-user', svg: require('@/assets/icons2026/message-user.svg'), badgeKey: 'inboxRecruitmentCustomerCount', navItem: 'conversation-recruitment_customer', label: RAIL_LABELS.recruitment_customer },
        recruitment_professional: { icon: 'fas fa-female', svg: require('@/assets/icons2026/ai-user.svg'), badgeKey: 'inboxRecruitmentProfessionalCount', navItem: 'conversation-recruitment_professional', label: RAIL_LABELS.recruitment_professional },
        recruitment_professional_secondary: { icon: 'fas fa-female', svg: require('@/assets/icons2026/ai-user.svg'), badgeKey: 'inboxRecruitmentProfessionalSecondaryCount', navItem: 'conversation-recruitment_professional_secondary', label: RAIL_LABELS.recruitment_professional_secondary },
        mari_customer: { icon: 'fas fa-user', svg: require('@/assets/icons2026/message-user.svg'), badgeKey: 'inboxMariCustomerCount', navItem: 'conversation-mari_customer', label: RAIL_LABELS.mari_customer },
        mari_professional: { icon: 'far fa-id-badge', svg: require('@/assets/icons2026/user-group.svg'), badgeKey: 'inboxMariProfessionalCount', navItem: 'conversation-mari_professional', label: RAIL_LABELS.mari_professional }
      },
      railBottomItems: {
        reports: { icon: 'fa fa-chart-line', svg: require('@/assets/icons2026/chart.svg') },
        settings: { icon: 'fa fa-tools', svg: require('@/assets/icons2026/settings.svg') }
      },
      bgColor: '#E91E63',
      fabActions: [
        {
          name: 'addUser',
          icon: 'fas fa-user-plus',
          tooltip: 'คุณลูกค้า'
        },
        {
          name: 'addApplicant',
          icon: 'fas fa-clipboard-user',
          tooltip: 'ผู้สมัคร',
          color: '#FFB74D'
        }
      ]
    }
  },
  computed: {
    ...mapState('admin', ['admin']),
    ...mapState('ticker', ['now']),
    ...mapState('conversation', ['customerType']),
    ...mapState('menu', ['menuCount']),

    // dropdown ไม่ได้ทำให้ rail กางเอง แค่ล็อกไม่ให้หุบ (railDropdownOpen กันทุกทางปิด)
    // ไม่งั้นแตะ avatar บนจอสัมผัสจะกาง rail ขึ้นมา
    railOpen () {
      return this.railHoverOpen
    },
    showAdminStatus () {
      const hideFixed = true
      return this.admin && !hideFixed
    },

    navItem: {
      get () {
        return this.$store.state.menu.navItem
      },
      set (value) {
        this.$store.commit('menu/SET_NAV_ITEM', value)
      }
    },
    railChatItems () {
      // สิทธิ์อยู่ที่ visibleRailTypes ที่เดียว (constants/railTypes.js) — ปุ่มอื่นที่ผูกกับ
      // "เห็น rail นี้ไหม" อ่านจากตัวเดียวกัน จะได้ไม่หลุดจากกันเวลาเปิด RAIL_DEV_MODE
      return applyRailOrder(visibleRailTypes(this.admin), this.railOrder)
        .filter(type => this.railTypeMap[type])
        .map(type => ({ type, ...this.railTypeMap[type] }))
    }
  },
  watch: {
    // แยกตามแอดมิน: login สลับคนบนเครื่องเดียวกันต้องได้ลำดับของคนนั้น
    'admin.id': {
      immediate: true,
      handler () {
        this.railOrder = loadRailOrder(this.admin)
      }
    },
    // .is-floating (z-index + เงา) ต้องค้างจนหุบเสร็จ ไม่งั้น panel ที่กำลังหดจะมุดใต้ drawer
    railOpen (open) {
      this.clearRailFloatTimer()
      if (open) {
        this.railFloating = true
      } else if (prefersReducedMotion()) {
        this.railFloating = false
      } else {
        this.railFloatTimer = setTimeout(() => {
          this.railFloatTimer = null
          if (!this.railOpen) this.railFloating = false
        }, RAIL_FLOAT_FALLBACK_MS)
      }
    }
  },
  methods: {
    ...mapActions('general', ['fetchShiftWorkTypes', 'fetchMessageLimits']),
    ...mapActions('admin', ['fetchAdmin', 'updateStatus']),
    ...mapActions('tag', ['fetchTags', 'fetchCoordinationTags']),
    ...mapActions('conversation', ['closeConversation']),
    clearRailOpenTimer () {
      if (this.railOpenTimer) {
        clearTimeout(this.railOpenTimer)
        this.railOpenTimer = null
      }
    },
    clearRailCloseTimer () {
      if (this.railCloseTimer) {
        clearTimeout(this.railCloseTimer)
        this.railCloseTimer = null
      }
    },
    clearRailFloatTimer () {
      if (this.railFloatTimer) {
        clearTimeout(this.railFloatTimer)
        this.railFloatTimer = null
      }
    },
    clearRailTimers () {
      this.clearRailOpenTimer()
      this.clearRailCloseTimer()
    },
    railHasKeyboardFocus () {
      const nav = this.$refs.railNav
      const active = document.activeElement
      return !!(nav && active && nav.contains(active) && matchesFocusVisible(active))
    },
    onRailPointerEnter (e) {
      if (e.pointerType === 'touch') return
      this.railPointerInside = true
      this.clearRailCloseTimer()
      if (this.railHoverOpen || this.railSuppressed) return
      this.clearRailOpenTimer()
      this.railOpenTimer = setTimeout(() => {
        this.railOpenTimer = null
        if (this.railPointerInside && !this.railSuppressed) this.railHoverOpen = true
      }, RAIL_HOVER_OPEN_MS)
    },
    onRailPointerLeave (e) {
      if (e.pointerType === 'touch') return
      this.railPointerInside = false
      this.clearRailOpenTimer()
      if (this.railSuppressed) {
        this.railSuppressed = false
        return
      }
      if (!this.railHoverOpen || this.railDropdownOpen) return
      this.clearRailCloseTimer()
      this.railCloseTimer = setTimeout(() => {
        this.railCloseTimer = null
        if (this.railPointerInside || this.railDropdownOpen || this.railHasKeyboardFocus()) return
        this.railHoverOpen = false
      }, RAIL_HOVER_CLOSE_MS)
    },
    onRailFocusIn (e) {
      // เฉพาะ focus จากคีย์บอร์ด: คลิกเมาส์/แตะก็ focus ปุ่มเหมือนกัน ถ้าไม่กรองจะกางกลับทันทีหลังคลิก
      if (this.railSuppressed || !matchesFocusVisible(e.target)) return
      this.clearRailTimers()
      this.railHoverOpen = true
    },
    onRailFocusOut (e) {
      const nav = this.$refs.railNav
      if (nav && e.relatedTarget && nav.contains(e.relatedTarget)) return
      this.railSuppressed = false
      if (this.railPointerInside || this.railDropdownOpen) return
      this.clearRailTimers()
      this.railHoverOpen = false
    },
    onRailEscape (e) {
      // Esc ใน dropdown เป็นของ BV (ปิดเมนูอย่างเดียว rail ยังกางอยู่)
      if (this.railDropdownOpen || !this.railHoverOpen) return
      this.clearRailTimers()
      this.railHoverOpen = false
      this.railSuppressed = true
    },
    onRailTransitionEnd (e) {
      if (e.target !== e.currentTarget || e.propertyName !== 'width' || this.railOpen) return
      this.clearRailFloatTimer()
      this.railFloating = false
    },
    // เรียกหลัง handler เดิมเสมอ (handler เดิมไม่แตะ) — หุบแล้วห้ามกางซ้ำจนกว่าเมาส์จะออกจริง
    openRailOrder () {
      this.collapseRailAfterChoice()
      this.showRailOrder = true
    },
    onSaveRailOrder (order) {
      saveRailOrder(this.admin, order)
      this.railOrder = order
      this.showRailOrder = false
    },
    onResetRailOrder () {
      clearRailOrder(this.admin)
      this.railOrder = null
      this.showRailOrder = false
    },
    collapseRailAfterChoice () {
      this.clearRailTimers()
      // แตะจากจอสัมผัส (ไม่เคยกาง ไม่นับ pointer) ไม่ต้อง suppress ไม่งั้นเมาส์ครั้งถัดไปต้องเข้าออกสองรอบ
      this.railSuppressed = this.railPointerInside || this.railHoverOpen
      this.railHoverOpen = false
    },
    onRailDropdownShown () {
      // เปิดจาก rail ที่ยังไม่กาง (แตะ / คลิกก่อน 150ms) ให้คงสภาพย่อ เมนูจะได้ไม่ถูกวางผิดที่
      if (!this.railHoverOpen) this.clearRailOpenTimer()
      this.railDropdownOpen = true
      this.clearRailCloseTimer()
    },
    onRailDropdownHidden () {
      this.railDropdownOpen = false
      if (!this.railHoverOpen) return
      const nav = this.$refs.railNav
      const focusInside = !!(nav && document.activeElement && nav.contains(document.activeElement))
      if (this.railPointerInside || focusInside) return
      this.clearRailTimers()
      this.railHoverOpen = false
    },
    onWindowBlur () {
      // รายงานเปิดเป็น popup: mouseleave อาจไม่ยิงเลย ต้องหุบเองตอนหน้าต่างเสีย focus
      this.clearRailTimers()
      if (this.railDropdownOpen && this.$refs.railAvatarDd) this.$refs.railAvatarDd.hide()
      this.railHoverOpen = false
      this.railSuppressed = true
    },
    onWindowFocus () {
      const nav = this.$refs.railNav
      let hovered = false
      try {
        hovered = !!(nav && nav.matches(':hover'))
      } catch (e) {
        hovered = false
      }
      if (hovered) return
      this.railSuppressed = false
      this.railPointerInside = false
    },
    openModalShiftWorkAdmin () {
      this.$refs.modalShiftWorkAdmin.openModal()
    },
    goToPage (path) {
      // let route = this.$router.resolve({ path })
      window.open(path, '_blank')
    },
    pressBrandLogo () {
      let customerType = 'customer'
      if (this.admin && this.admin.customer_types) {
        customerType = this.admin.customer_types.types[0]
        switch (customerType) {
          case 'customer':
            this.setNavItem('conversation-customer')
            break
          case 'beneat_professional':
            this.setNavItem('conversation-beneat-professional')
            break
          case 'professional':
            this.setNavItem('conversation-professional')
            break
          case 'professional_secondary':
            this.setNavItem('conversation-professional_secondary')
            break
          case 'sales_product_customer':
            this.setNavItem('conversation-sales_product_customer')
            break
          case 'recruitment_customer':
            this.setNavItem('conversation-recruitment_customer')
            break
          case 'recruitment_professional':
            this.setNavItem('conversation-recruitment_professional')
            break
          case 'recruitment_professional_secondary':
            this.setNavItem('conversation-recruitment_professional_secondary')
            break
          case 'mari_customer':
            this.setNavItem('conversation-mari_customer')
            break
          case 'mari_professional':
            this.setNavItem('conversation-mari_professional')
            break
        }
      } else {
        this.setNavItem('conversation-customer')
      }
    },
    onClickRailChat (item) {
      this.setNavItem(item.navItem)
      this.goToConversations()
    },
    onClickLogo () {
      this.pressBrandLogo()
      this.goToConversations()
    },
    goToConversations () {
      if (this.$route.name !== 'conversations') {
        this.$router.push({ name: 'conversations' }).catch(() => {})
      }
    },
    onClickSettings () {
      this.setNavItem('settings')
      if (this.$route.path !== '/settings') {
        this.$router.push('/settings').catch(() => {})
      }
    },
    openDashboard () {
      let { href } = this.$router.resolve({ path: '/dashboard' })
      window.open(href, '_blank', 'width=1080, height=768, scrollbars=yes, status=yes')
    },
    setNavItem (navItem) {
      this.navItem = navItem
      let customerType = 'customer'
      if (navItem === 'conversation-professional') {
        customerType = 'professional'
      } else if (navItem === 'conversation-professional_secondary') {
        customerType = 'professional_secondary'
      } else if (navItem === 'conversation-beneat-professional') {
        customerType = 'beneat_professional'
      } else if (navItem === 'conversation-sales_product_customer') {
        customerType = 'sales_product_customer'
      } else if (navItem === 'conversation-recruitment_customer') {
        customerType = 'recruitment_customer'
      } else if (navItem === 'conversation-recruitment_professional') {
        customerType = 'recruitment_professional'
      } else if (navItem === 'conversation-recruitment_professional_secondary') {
        customerType = 'recruitment_professional_secondary'
      } else if (navItem === 'conversation-mari_customer') {
        customerType = 'mari_customer'
      } else if (navItem === 'conversation-mari_professional') {
        customerType = 'mari_professional'
      }

      if (this.navItem !== navItem) {
        this.$refs.searchConversation.clearSearch(true)
      }

      this.$store.commit('conversation/SET_CUSTOMER_TYPE', customerType)
      this.fetchTags({ include_count: false, customer_type: customerType, system: 0 })
    },
    openUpdateAdminStatusModal () {
      this.updateAdminStatusSubmitData = {
        id: this.admin.id,
        active: this.admin.active,
        remark: ''
      }
      this.$refs.updateAdminStatusModal.open()
    },
    getAdminActiveTime (now) {
      if (this.active || !this.admin.logs || !this.admin.logs.length) {
        return { online: '00:00:00', pause: '00:00:00' }
      }
      let activeSecs = 0
      let lastActive = null
      let pauseSecs = 0
      let lastPause = null
      let firstOnlineLog = null
      for (let i = 0; i < this.admin.logs.length; i++) {
        const log = this.admin.logs[i]
        if (log.active === 1) {
          if (!firstOnlineLog) {
            firstOnlineLog = log
          }
          if (lastPause) {
            pauseSecs += moment(log.created_at).diff(lastPause, 'seconds')
            lastPause = null
          }
          lastActive = moment(log.created_at)
        } else if (log.active === 2) {
          if (!firstOnlineLog) {
            continue
          }
          if (lastActive) {
            activeSecs += moment(log.created_at).diff(lastActive, 'seconds')
            lastActive = null
          }
          lastPause = moment(log.created_at)
        } else if (log.active === 0) {
          if (!firstOnlineLog) {
            continue
          }
          if (lastActive) {
            activeSecs += moment(log.created_at).diff(lastActive, 'seconds')
            lastActive = null
          }
          if (lastPause) {
            pauseSecs += moment(log.created_at).diff(lastPause, 'seconds')
            lastPause = null
          }
        }
      }
      if (this.admin.active === 1 && lastActive) {
        activeSecs += moment().diff(lastActive, 'seconds')
      } else if (this.admin.active === 2 && lastPause) {
        pauseSecs += moment().diff(lastPause, 'seconds')
      }
      return { online: this.$options.filters.relativeTimeSpanTicker(activeSecs), pause: this.$options.filters.relativeTimeSpanTicker(pauseSecs) }
    },
    async updateAdminStatus () {
      await this.updateStatus(this.updateAdminStatusSubmitData)
      this.$refs.updateAdminStatusModal.close()
    },
    logout () {
      this.$swal({
        text: 'คุณต้องการออกจากระบบใช่หรือไม่',
        showCancelButton: true,
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        if (result.isConfirmed) {
          let params = {
            admin_id: this.admin.id
          }
          await this.closeConversation(params)

          await this.$store.dispatch('admin/LOGOUT')
          this.$router.replace({ name: 'login' })
        }
      })
    }
  },
  mounted () {
    // per-platform outgoing text limits — read-only, falls back to the local copy if it fails
    this.fetchMessageLimits()
    let customerType = 'customer'
    if (this.$route.path === '/' || this.$route.path === '/conversations') {
      if (this.admin && this.admin.customer_types) {
        customerType = this.admin.customer_types.types[0]
        switch (customerType) {
          case 'customer':
            this.navItem = 'conversation-customer'
            break
          case 'beneat_professional':
            this.navItem = 'conversation-beneat-professional'
            break
          case 'professional':
            this.navItem = 'conversation-professional'
            break
          case 'professional_secondary':
            this.navItem = 'conversation-professional_secondary'
            break
          case 'sales_product_customer':
            this.navItem = 'conversation-sales_product_customer'
            break
          case 'recruitment_customer':
            this.navItem = 'conversation-recruitment_customer'
            break
          case 'recruitment_professional':
            this.navItem = 'conversation-recruitment_professional'
            break
          case 'recruitment_professional_secondary':
            this.navItem = 'conversation-recruitment_professional_secondary'
            break
          case 'mari_customer':
            this.navItem = 'conversation-mari_customer'
            break
          case 'mari_professional':
            this.navItem = 'conversation-mari_professional'
            break
        }
      } else {
        this.navItem = 'conversation-customer'
      }
      if (this.$route.path === '/') {
        this.$router.push('/conversations')
      }
      this.$store.commit('conversation/SET_CUSTOMER_TYPE', customerType)
    }
    // this.fetchCoordinationTags()
    // this.fetchShiftWorkTypes()
  },
  created () {
    // timer id ไม่ต้อง reactive จึงไม่อยู่ใน data
    this.railOpenTimer = null
    this.railCloseTimer = null
    this.railFloatTimer = null
    window.addEventListener('blur', this.onWindowBlur)
    window.addEventListener('focus', this.onWindowFocus)
    window.addEventListener('beforeunload', (e) => {
      let params = {
        admin_id: this.admin && this.admin.id ? this.admin.id : null
      }
      this.closeConversation(params)
      e.preventDefault()
      e.returnValue = ''
    })
  },
  beforeDestroy () {
    this.clearRailTimers()
    this.clearRailFloatTimer()
    window.removeEventListener('blur', this.onWindowBlur)
    window.removeEventListener('focus', this.onWindowFocus)
  }
}
</script>

<style lang="scss" scoped>
ul.navbar-nav li.nav-item a.nav-link {
  font-size: 85%;
}

.admin-status {
  display: flex;
  padding-left: 0.5rem;
  align-items: center;
}

/* --v2026-header-h is mirrored in JS as V2026_HEADER_HEIGHT; the two must stay equal. */
.v2026-shell {
  --v2026-header-h: 64px;

  --v2026-color-main: #31C1D7;
  --v2026-color-main-soft: #31C1D714;
  --v2026-color-main-bar: var(--v2026-color-main);
  --v2026-color-main-icon: var(--v2026-color-main);
  /* never near-white: this cascades into every forked 2026 child */
  --v2026-color-icon-idle: #66696C;
  --v2026-color-rail-icon-idle: #66696C;
  --v2026-color-hover-bg: #f5f5f5;
  --v2026-color-count: #FF2D55;
  --v2026-color-count-soft: #FF2D5514;
  /* #FF2D55 on the pale pink strip is 3.13:1 and fails AA; this is 4.84:1 */
  --v2026-color-count-deep: #C81E43;
  --v2026-color-fire: #F2994A;
  /* Incognito family. Not a new colour: #48484A is the incognito reading mode's own header bar
     (MainPanelV2026.vue), promoted to a token so the chat card's rail can reuse it. */
  --v2026-color-stealth: #48484A;
  --v2026-color-stealth-soft: #48484A14;   /* 8% */

  --color-bg-start: #f3f3f3;
  --color-bg-end: #c9f5fc;

  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.v2026-header {
  flex: 0 0 var(--v2026-header-h);
  height: var(--v2026-header-h);
  display: flex;
  align-items: center;
  padding: 0 16px;
  background: #ffffff;
  background: linear-gradient(to right, var(--color-bg-start), var(--color-bg-end));
  border-bottom: 1px solid #e9ecef;
}

.v2026-header-logo {
  display: inline-flex;
  align-items: center;
}

.v2026-header-logo img {
  height: 36px;
  object-fit: contain;
}

.v2026-header-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-size: 13px;
}

.v2026-header-timer {
  margin-right: 16px;
}

.v2026-header-status {
  margin-right: 16px;

  a {
    text-decoration: none;
  }
}

.v2026-body {
  flex: 1 1 auto;
  display: flex;
  min-height: 0;
  overflow: hidden;
}

.v2026-main {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  overflow: hidden;
}

/* ถือพื้นที่ 64px ใน flex แทน nav ที่ถูกยกออกจาก flow แล้ว */
.v2026-rail-slot {
  position: relative;
  flex: 0 0 64px;
  width: 64px;
  height: 100%;
}

/* ห้ามใส่ z-index ที่กฎฐาน: rail ที่ย่ออยู่ต้องไม่ลอยเหนือ modal backdrop (1040) */
.v2026-rail {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 64px;
  background: #ffffff;
  border-right: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0;
}

/* ตอนย่อไม่มี overflow และไม่มี min-height: 0 ให้ layout ตรงกับ rail เดิมทุกพิกเซล */
.v2026-rail-scroll {
  flex: 1 1 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.v2026-rail-item {
  position: relative;
  border: none;
  background: transparent;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  margin: 4px 0;
  color: var(--v2026-color-rail-icon-idle);
  font-size: 20px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #212529;
    background: var(--v2026-color-hover-bg);
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(49, 193, 215, .30);
  }

  &.is-active {
    color: var(--v2026-color-main-icon);
    background: var(--v2026-color-main-soft);

    &::before {
      content: '';
      position: absolute;
      left: -8px;
      top: 10px;
      bottom: 10px;
      width: 3px;
      border-radius: 2px;
      background: var(--v2026-color-main-bar);
    }

    .v2026-rail-svg-mask {
      background-color: var(--v2026-color-main);
    }
  }
}

.v2026-rail-svg-mask {
  display: inline-block;
  width: 20px;
  height: 20px;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: var(--v2026-color-rail-icon-idle);
}

.v2026-rail-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  transform: translate(50%, -50%);
  min-width: 18px;
  font-size: 10px;
  border-radius: 9px;

  background: var(--v2026-color-count);
}

.v2026-rail-item--edit {
  height: 36px;
  font-size: 14px;
}

.v2026-rail-spacer {
  flex: 1 1 auto;
}

.v2026-rail-avatar-dd {
  margin-top: 8px;

  ::v-deep .dropdown-toggle:focus {
    box-shadow: none;
  }

  ::v-deep .dropdown-toggle:focus-visible {
    box-shadow: 0 0 0 3px rgba(49, 193, 215, .30);
    border-radius: 10px;
  }
}

.v2026-avatar-menu-name {
  font-weight: 600;
  color: #212529;
}

.v2026-rail-avatar {
  position: relative;
  display: inline-block;
}

.v2026-rail-avatar img {
  width: 32px;
  height: 32px;
  object-fit: cover;
}

.v2026-online-dot {
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  background: #adb5bd;

  &.is-online {
    background: #28a745;
  }
}

/* ทุกอย่างของสถานะกางอยู่ใต้คลาสนี้เท่านั้น กฎเดิมของ rail ที่ย่อห้ามแตะ */
.v2026-rail {
  /* animate แค่ width/box-shadow ห้าม transform/filter/will-change บน nav หรือ ancestor */
  transition: width .2s cubic-bezier(.2, 0, 0, 1), box-shadow .2s ease;

  /* ค้างตั้งแต่เริ่มกางจนหุบเสร็จ (คุมใน JS) */
  &.is-floating {
    z-index: 1045;
    /* clip ไม่ใช่ scroll container: popper/dropup ไม่ถูกตัดแนวตั้ง ห้ามเปลี่ยนเป็น overflow: hidden */
    overflow-x: clip;
    box-shadow: 4px 0 24px rgba(16, 24, 40, .15);
  }

  &.is-expanded {
    width: 260px;
    align-items: stretch;

    /* overflow อยู่ที่ wrapper ไม่ใช่ nav: dropup ของ avatar อยู่นอก wrapper จึงไม่ถูกตัด */
    .v2026-rail-scroll {
      align-self: flex-start;
      /* ความกว้างปลายทางคงที่ (260 − border 1px) label จึงตัดบรรทัดครั้งเดียว ไม่ reflow ระหว่าง animate */
      width: 259px;
      min-height: 0;
      align-items: stretch;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 0;
    }

    .v2026-rail-item {
      flex: 0 0 auto;
      width: auto;
      height: auto;
      min-height: 48px;
      margin: 4px 8px;
      /* 14 ไม่ใช่ 12: ไอคอน 20px จะได้อยู่กึ่งกลาง x=32 เท่ากับตอนย่อ สลับสถานะแล้วไอคอนไม่ขยับ */
      padding: 4px 12px 4px 14px;
      justify-content: flex-start;

      &.is-active:hover {
        color: var(--v2026-color-main-icon);
        background: var(--v2026-color-main-soft);
      }

      &:hover .v2026-rail-label {
        color: #212529;
      }

      &.is-active .v2026-rail-label {
        color: var(--v2026-color-main-icon);
        font-weight: 600;
      }
    }

    .v2026-rail-svg-mask {
      flex: 0 0 auto;
    }

    .v2026-rail-badge {
      position: static;
      transform: none;
      flex: 0 0 auto;
      align-self: center;
      margin-left: auto;
      min-width: 28px;
    }

    .v2026-rail-avatar-dd {
      align-self: flex-start;
      /* 259 − margin 8px สองข้าง */
      width: 243px;
      flex: 0 0 auto;
      margin: 8px 8px 0;

      ::v-deep .dropdown-toggle {
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 48px;
        /* .btn มี border 1px transparent ถ้าไม่ตัดทิ้ง avatar จะเลื่อนไป x=33 ไม่ตรงกับไอคอนแถวบน */
        border: 0;
        border-radius: 10px;
        /* p-0 มาจาก toggle-class ของ b-dropdown ซึ่งเป็น !important */
        padding: 4px 12px 4px 8px !important;

        &:hover {
          background: var(--v2026-color-hover-bg);
        }

        &::after {
          margin-left: auto;
        }
      }
    }

    .v2026-rail-label,
    .v2026-rail-name {
      animation: v2026-rail-label-in .12s ease .06s both;
    }
  }
}

@keyframes v2026-rail-label-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.v2026-rail-label {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 152px;
  margin: 0 5px 0 12px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #343a40;
  text-align: left;
  white-space: normal;
  /* ห้าม break-word เด็ดขาด มันตัดกลางคลัสเตอร์อักษรไทย */
  overflow-wrap: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.v2026-rail-name {
  min-width: 0;
  max-width: 152px;
  margin-left: 6px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: #343a40;
  text-align: left;
  white-space: normal;
  overflow-wrap: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media (prefers-reduced-motion: reduce) {
  .v2026-rail {
    transition: none;
  }

  /* ต้อง specificity เท่ากฎใน .is-expanded ไม่งั้นไม่ชนะ */
  .v2026-rail.is-expanded .v2026-rail-label,
  .v2026-rail.is-expanded .v2026-rail-name {
    animation: none;
  }
}
</style>
